import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconBookmark24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconBookmark24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m12 15.495.867.614L18.5 20.1V5A1.5 1.5 0 0 0 17 3.5H7A1.5 1.5 0 0 0 5.5 5v15.1l5.633-3.99zm0 1.838 5.633 3.99c.993.704 2.367-.006 2.367-1.224V5a3 3 0 0 0-3-3H7a3 3 0 0 0-3 3v15.1c0 1.217 1.374 1.927 2.367 1.223z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconBookmark24);
